import { Column, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';
import React from 'react';

interface UsageDetailsTableHeaderProps {
  columnDetails: any[];
}

export const UsageDetailsTableHeader: React.FC<
  UsageDetailsTableHeaderProps
> = ({ columnDetails }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className='gap-x-3 px-4 py-3 bg-secondary-50 flex items-center'>
        {columnDetails.map((colData, ind) => {
          return (
            <Column
              key={ind}
              width={colData.width}
              className={classNames(
                'text-2xs font-medium text-unique-600 leading-4 flex items-center',
                colData.className,
              )}>
              {t(colData.label)}
            </Column>
          );
        })}
      </div>
    </>
  );
};
